import { SeriesScopeTargetsResponse } from "../../../features/Schedule/series-booking.types";
import { useRemoteQuery } from "../../../hooks/Remote/useRemote/useRemoteQuery";

/**
 * Loads the days each series scope will change.
 * The request runs only while the scope dialog is open.
 */
export function useSeriesScopeTargets(
  bookingId: number | undefined,
  bookingType: string | undefined,
  open: boolean
) {
  const enabled = open && bookingId != null && bookingType != null && bookingType.length > 0;

  return useRemoteQuery<SeriesScopeTargetsResponse>({
    queryKey: ["series-scope-targets", bookingId, bookingType],
    url: "/booking/series-scope-targets",
    params: { bookingId, bookingType },
    enabled
  });
}
